import { createAction } from '@reduxjs/toolkit'

import { SimTable } from 'types/transformation/types/tables'

export const getOneSIMTable = createAction('get_one_sim_table')
export const getOneSIMTableSuccess = createAction<SimTable>(
  'get_one_sim_table_success'
)
export const getOneSIMTableFailed = createAction('get_one_sim_table_failed')

export const putSIMTable = createAction('put_sim_table')
export const putSIMTableSuccess = createAction<SimTable>(
  'put_sim_table_success'
)
export const putSIMTableFailed = createAction('put_sim_table_failed')
